module.exports = __webpack_public_path__ + "img/bg02.0091b368.jpg";